import axios from 'axios'
export default {
    GETEVENTLIST ({ commit }) {
        return axios.get(`/events`).then((response) => {
            const { data: { data } } = response
            // Set Events List
            commit('setEventList', {eventList: data})
            // Set Main Event
            commit('setMainEvent', {mainEvent: data[0]})
            // Exclude Main event from rest of list
            let allEvents = data.filter(event => {
                return event.eventId !== data[0].eventId
            })
            // Set Talk Events
            let talkEvents = allEvents.filter(event => {
                return event.type === '2'
            })
            commit('setTalkEvents', {talkEvent: talkEvents})
            // Loop thru and set Experts
            // let talkExperts = []
            // talkEvents.forEach(function (event) {
            //     return axios.get(`/experts/${event.expertId}`).then((response) => {
            //         const { data: { data } } = response
            //         talkExperts.push(data[0])
            //     }, (err) => {
            //         console.log('err ', err)
            //     })
            // })
            // commit('setTalkExperts', {exp: talkExperts})
            // Set Live Events
            let liveEvents = allEvents.filter(event => {
                return event.type === '1'
            })
            commit('setLiveEvents', {liveEvent: liveEvents})
            // let liveExperts = []
            // liveEvents.forEach(function (event) {
            //     return axios.get(`/experts/${event.expertId}`).then((response) => {
            //         const { data: { data } } = response
            //         liveExperts.push(data[0])
            //     }, (err) => {
            //         console.log('err ', err)
            //     })
            // })
            // commit('setLiveExperts', {exp: liveExperts})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETADMINEVENTS ({commit}) {
        console.info('called for admin')
        return axios.get(`/corporations/getToneAndCorpPrivNonPhysicalEvents`).then((response) => {
            const { data: { data } } = response
            // Set Admin Events List
            commit('setEventList', {eventList: data})
        }, (err) => {
            commit('setEventList', {eventList: null})
            console.log('err ', err)
        })
    },
    GET_UPCOMING_EVENT ({commit}) {
        return axios.get(`/events`).then((response) => {
            const { data: { data } } = response
            if (data && data.length > 0) {
                commit('setUpcomingEvent', {event: data[0]})
            } else {
                commit('setUpcomingEvent', {event: null})
            }
            // commit('setUpcomingEvent', {event: data})
        }, (err) => {
            commit('setUpcomingEvent', {event: null})
            console.log('err ', err)
        })
    },
    GETBANNEREVENT ({commit}, userId) {
    },
    GETMONTHEVETNSLIST ({commit}) {
        return axios.get(`/events/getCurrMonthEvents`).then((response) => {
            const { data: { data } } = response
            commit('setMonthEvents', {monEvents: data})
        }, (err) => {
            commit('setMonthEvents', {monEvents: null})
            console.log('err ', err)
        })
    },
    GETDEMOEVENTS ({commit}) {
        return axios.get(`/events/loadPrivateEventDemo`).then((response) => {
            const { data: { data } } = response
            commit('setDemoEvent', {event: data.payload})
        }, (err) => {
            commit('setDemoEvent', {event: null})
            console.log('err ', err)
        })
    },
    GETUSEREVENTS ({ commit }, userId) {
        return axios.get(`/events/getByUserId/${userId}`).then((response) => {
            const { data: { data } } = response
            commit('setUserEvents', {events: data})
        }, (err) => {
            console.log('ERROR in GETUSEREVENTS ====> err = ', err)
        })
    },
    SEATRESERVATION ({ commit }, event) {
        return axios.post(`/events/addUserEvents`, event).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {}
        }, (err) => {
            console.log('err ', err)
        })
    },
    UPDATERESERVATION ({ commit }, event) {
        return axios.put(`/events/updateUserEvents`, event).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {}
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETSELECTEDEVENT ({ commit }, eventId) {
        return axios.get(`/events/getByEventId/${eventId}`).then((response) => {
            const { data: { data } } = response
            commit('setSelectedEvent', {event: data})
            console.log('inside action.js -> GETSELECTEDEVENT ===> data ', data)
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETEVENTUSERS ({ commit }, eventId) {
        return axios.get(`/events/getAudienceByEventId/${eventId}`).then((response) => {
            const { data: { data } } = response
            commit('setEventUsers', {users: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GENERATESIGNATURE ({ commit }, userId) {
        return axios.get(`/events/getChatRollSig/${userId}`).then((response) => {
            const { data: { data } } = response
            commit('setUserStatus', {isAnyony: '0'})
            commit('setUserSig', {sig: data})
        }, (err) => {
            console.log('ERROR in GENERATESIGNATURE ====> err ', err)
        })
    },
    GENERATE_UNAUTH_SIGNATURE ({ commit }, status) {
        return axios.get(`/events/getChatRollSigUnauth/${parseInt(status)}`).then((response) => {
            const { data: { data } } = response
            if (status === '1') {
                commit('setDemoUserStatus', 1)
            } else {
                commit('setDemoUserStatus', 0)
            }
            commit('setUnAuthUserSig', {sig: data})
        }, (err) => {
            commit('setUnAuthUserSig', {sig: null})
            commit('setDemoUserStatus', null)
            console.log('err ', err)
        })
    },
    LEAVEEVENT ({ commit }) {
        commit('setUserSig', {sig: null})
    },
    SETBANNEREVENT ({ commit }, eventId) {
        commit('setBannerEvent', eventId)
    },
    GENERATESIGNATUREWITHEVENT ({ commit }, event) {
        return axios.post(`/events/getChatRollSig`, event).then((response) => {
            const { data: { data } } = response
            commit('setUserStatus', {isAnyony: '1'})
            commit('setUserSig', {sig: data})
        }, (err) => {
            console.log('ERROR in GENERATESIGNATUREWITHEVENT ==== > err ', err)
        })
    },
    GETEVENTSARCHIVE ({ commit }) {
        return axios.get(`/events/getToneLiveEvents`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setLiveEventsArchive', {liveArchive: data.payload})
            } else {
                commit('setLiveEventsArchive', {liveArchive: null})
            }
        }, (err) => {
            commit('setLiveEventsArchive', {liveArchive: null})
            console.log('err ', err)
        })
    },
    GETCORPEVENTSARCHIVE ({ commit }, coprId) {
        return axios.get(`/events/getCorporationArchiveEvents/${coprId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                console.log('data returned', data)
                commit('setCorpArchiveEvents', {aEvents: data.payload})
            } else {
                commit('setCorpArchiveEvents', {aEvents: null})
            }
        }, (err) => {
            commit('setCorpArchiveEvents', {aEvents: null})
            console.log('err ', err)
        })
    },
    GETCORPPRIVATEVIDEOS ({ commit }, coprId) {
        return axios.get(`/playlists/getCorpShowHideVideoDetail/${coprId}/1`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorpPrivateVideos', {videos: data.payload})
            } else {
                commit('setCorpPrivateVideos', {videos: null})
            }
        }, (err) => {
            commit('setCorpPrivateVideos', {videos: null})
            console.log('err ', err)
        })
    },
    GETCORPPLAYLISTS ({ commit }, coprId) {
        return axios.get(`/corporations/getCorporationPlaylists/${coprId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorpPlaylists', {playlist: data.payload})
            } else {
                commit('setCorpPlaylists', {playlist: null})
            }
        }, (err) => {
            commit('setCorpPlaylists', {playlist: null})
            console.log('err ', err)
        })
    },
    GETEVENTSARCHIVEPLAYLIST ({ commit }) {
        return axios.get(`/playlists/getJWPlaylistByTitle/ARCHIVETESTPLAYLIST/0`).then((response) => {
            const { data: { data } } = response
            commit('setArchivePlaylist', {arplaylist: data})
        }, (err) => {
            commit('setArchivePlaylist', {arplaylist: null})
            console.log('err ', err)
        })
    },
    GETEVENTSARCHIVEPLAYLIST_EVENTID ({ commit }, eventId) {
        return axios.get(`/playlists/loadArchiveEventPlaylist/${eventId}`).then((response) => {
            const { data: { data } } = response
            commit('setArchivePlaylist', {arplaylist: data})
        }, (err) => {
            commit('setArchivePlaylist', {arplaylist: null})
            console.log('err ', err)
        })
    },
    GET_ARCHIVE_EVENT_PLAYLIST_BY_EVENTID ({ commit }, eventId) {
        return axios.get(`playlists/loadArchivePlaylistForNewPlayer/${eventId}`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setArchivePlaylistObject', {eList: data})
            } else {
                commit('setArchivePlaylistObject', {eList: null})
            }
        }, (err) => {
            commit('setArchivePlaylistObject', {eList: null})
            console.log('err ', err)
        })
    },
    GETCORPEVENTS ({ commit }, corporationId) {
        return axios.get(`/corporations/getCorporationEvents/${corporationId}`).then((response) => {
            const { data: { data } } = response
            if (data && data.length > 0) {
                commit('setCorpAllEvents', {pEvents: data})
                // Check if corporation has private events
                let privateEvents = data.filter(x => {
                    return x.corporationId === corporationId
                })
                if (privateEvents && privateEvents.length > 0) { // Private Events Exist
                    let mainEvent = privateEvents[0]
                    commit('setCorpMainEvent', {pEvents: mainEvent})
                    let otherPrivateEvents = privateEvents.filter(x => {
                        return (x.eventId !== mainEvent.eventId)
                    })
                    if (otherPrivateEvents && otherPrivateEvents.length > 0) {
                        commit('setCorpPrivateEvents', {pEvents: otherPrivateEvents})
                    } else {
                        commit('setCorpPrivateEvents', {pEvents: null})
                    }
                    let allPublicEvents = data.filter(x => {
                        return x.corporationId === 0
                    })
                    if (allPublicEvents && allPublicEvents.length > 0) {
                        commit('setCorpPublicEvents', {pEvents: allPublicEvents})
                    } else {
                        commit('setCorpPublicEvents', {pEvents: null})
                    }
                } else { // no Private events
                    console.info('inside public section')
                    commit('setCorpPrivateEvents', {pEvents: null})
                    let mainEvent = data[0]
                    commit('setCorpMainEvent', {pEvents: mainEvent})
                    let allPublicEvents = data.filter(x => {
                        return x.eventId !== mainEvent.eventId
                    })
                    if (allPublicEvents && allPublicEvents.length > 0) {
                        commit('setCorpPublicEvents', {pEvents: allPublicEvents})
                    } else {
                        commit('setCorpPublicEvents', {pEvents: null})
                    }
                }
            }
        }, (err) => {
            console.log('err ', err)
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/events/actions.js